import React from "react";
import ProfilePlaceholderIcon from "./Icons/ProfilePlaceholderIcon";

type ProfilePhotoPlaceholderProps = {
  className?: string;
};

const ProfilePhotoPlaceholder: React.FC<ProfilePhotoPlaceholderProps> = ({
  className = "",
}) => (
  <div
    className={`flex h-full w-full items-center justify-center overflow-hidden rounded-full ${className}`}
    aria-hidden
  >
    <span className="block h-full w-full min-h-0 min-w-0 [&_img]:h-full [&_img]:w-full">
      <ProfilePlaceholderIcon />
    </span>
  </div>
);

export default ProfilePhotoPlaceholder;
